import { alpha } from "@mui/material/styles"
import { dsColorNew } from "@palette"


const overrideCardStyles = () => ({
	MuiCard: {
		styleOverrides: {
			root: {
				backgroundColor: dsColorNew.white,
				border: `1px solid ${dsColorNew.grayBorder}`,
				borderRadius: 16,
				boxShadow: `0 1px 2px ${alpha(dsColorNew.navy, 0.04)}`,
				transition: 'box-shadow .18s, border-color .18s, transform .18s',
				'&:hover': {
					boxShadow: `0 10px 28px ${alpha(dsColorNew.navy, 0.08)}`,
				},
			}
		}
	}
})

export default overrideCardStyles
